import { configureStore } from "@reduxjs/toolkit";
import refreshTokenReducer from "./features/refreshToken/refreshToken";
import loginReducer from "./features/login/login";
import verifyPANReducer from "./features/verifyPAN/verifyPAN";
import dateReducer from "./features/date/date";
import hideBreadCrumbReducer from "./features/hideBreadCrumb/hideBreadCrumb";
import verification from "./features/verification/verification";
import AuthMatrix from "./features/Settings/Authorization/index";
import entitiesReducer from "./features/Settings/Management/entities/index";
import homeDashCalender from "./features/HomeDashboard/homeDashCalender";
import servicesReducer from "./features/Settings/Management/Services/index";
import usersReducer from "./features/Settings/Management/Users/index";
import beneCreateAccountReducer from "./features/accounts/BeneficiaryAccount/createAccount";
import beneViewAllAccReducer from "./features/beneficiary/beneAllVerification/beneAllVerification";
import beneDetailDenyAccReducer from "./features/beneficiary/beneAllVerification/beneAllVerification";
import beneAllVerificationReducer from "./features/beneficiary/beneAllVerification/beneAllVerification";
import ownerAllVerificationReducer from "./features/owner/ownerAllVerification/ownerAllVerification";
import beneDashboardReducer from "./features/beneficiary/beneAllVerification/beneAllVerification";
import beneRequiredApprovalReducer from "./features/beneficiary/beneAllVerification/beneAllVerification";
import beneViewAccDataReducer from "./features/beneficiary/beneViewAccData/beneViewAccData";
import beneTxnViewAccDataReducer from "./features/beneficiary/beneTxnViewAccData/beneTxnViewAccData";
import beneTransactionAccountsReducer from "./features/beneficiary/beneTxnAccounts/beneTransactionAccounts";
import userSliceReducer from "./features/users/index";
import devicesSlice from "./features/devices/devices";
import getUserDetailsState from "./features/users/userDetails";
import bbpsAccountSlice from "./features/BBPS/index";
import internalSlice from "./features/internalApi/internalApi.js";
import landingpagestate from "./features/landingpagestate/landingpagestate";
import internalTxnViewAllDataSlice from "./features/internalTransaction/internalTransactionViewAll";
import internalTxnDataReducer from "./features/internalTransaction/internalTransactionDetailPage";
import InternalTxnSingleApprovalReducer from "./features/internalTransaction/internalTransactionSingleApproval";
import InternalTransactionCreateReducer from "./features/internalTransaction/internalTransactionCreate";
import schedulesTxnSlice from "./features/scheduleTransaction/index.js";
import { default as ViewAllAccountInternalDataSlice } from "./features/InternalAccount/ViewAllAccountInternal.js";
import totp from "../redux/features/totp/totp.js";
import xpentraLogoutSlice from "./features/logout/logout.js";
import invoicesSlice from "./features/Settings/Management/Invoices/index.js";
import rolesSlice from "./features/Settings/Management/Roles/index.js";
import featuresSlice from "./features/Settings/Management/Features/index.js";
import byok from "./features/byok/byok.js";
import scheduleInternalTxnSlice from "./features/scheduleInternalTxn/index.js";
import reminderTxnSlice from "./features/reminderTransaction/index.js";
import TestAuthMatrix from "./features/Settings/TestAuthMatrix/index.js";
import customCategoryReducer from "./features/customCategory/index.js";
import beneCreateAccountSlice from "./features/accounts/BeneficiaryAccount/createAccount.js";
import multientitySlice from "./features/multientity/multientity.js";
import internalAccLabelSlice from "./features/InternalAccount/internalAccount.js";
import multiEntitySwitcherSlice from "./features/multiEntitySwitcher/multiEntitySwitcher.js";
import settingStatistics from "./features/Settings/Statistics/index.js";
import privateTransactionsReducer from "./features/privatetransactions/privatetransactions.js";
import rolesReducer from "./features/Settings/Management/Roles/index.js";
import reimbursementRequest from "./features/reimbursementRequest/index.js";
import reimbursementTransaction from "./features/reimbursementTransaction/index.js";
import taxCompliantAccountDetailReducer from "./features/accounts/taxAccount/taxAccountDetails.js";
import taxCompliantViewAllReducer from "./features/accounts/taxAccount/taxAccountViewAll.js";
import taxCompliantApproveRejectAccountReducer from "./features/accounts/taxAccount/taxAccountApproval.js";
import taxCompliantAccountReducer from "./features/accounts/taxAccount/taxAccountCreateEdit.js";
import tdsTransactionApprovalReducer from "./features/transactions/taxTransaction/taxTransactionApproval.js";
import tdsTransactionDetailsReducer from "./features/transactions/taxTransaction/taxTransactionDetails.js";
import createTdsTransactionReducer from "./features/transactions/taxTransaction/taxTransactionCreate.js";
import tdsTxnViewAllReducer from "./features/transactions/taxTransaction/taxTransactionViewAll.js";
import { injectStore } from "./globalInspector/axiosInstance";
import ReimburseAccount from "../redux/features/accounts/ReimburseAccount/index.js";
import fieldForceAccount from "../redux/features/accounts/fieldForceAccount/index.js";
import fieldForceRequest from "../redux/features/fieldForceRequest/index.js";
import fieldForceTransaction from "../redux/features/fieldForceTransaction/index.js";
import remitterAccountReducer from "../redux/features/accounts/remitterAccount/remitterAccount.js";

export const store = configureStore({
  reducer: {
    refreshToken: refreshTokenReducer,
    login: loginReducer,
    internalAcc: internalSlice,
    verify: verifyPANReducer,
    totp: totp,
    byok: byok,
    multientity: multientitySlice,
    date: dateReducer,
    hideBreadCrumb: hideBreadCrumbReducer,
    verification: verification,
    AuthMatrix: AuthMatrix,
    entities: entitiesReducer,
    users: usersReducer,
    services: servicesReducer,
    beneCreateAccount: beneCreateAccountReducer,
    beneAllVerification: beneAllVerificationReducer,
    beneViewAllAcc: beneViewAllAccReducer,
    beneDashboardAcc: beneDashboardReducer,
    beneRequiredApprovalAcc: beneRequiredApprovalReducer,
    beneViewAccData: beneViewAccDataReducer,
    beneTxnViewAccData: beneTxnViewAccDataReducer,
    beneDetailDenyAcc: beneDetailDenyAccReducer,
    // ReimbursementTxnViewAccData: ReimbursementTxnViewReducer,
    beneTransactionAccounts: beneTransactionAccountsReducer,
    ownerAllVerification: ownerAllVerificationReducer,
    user: userSliceReducer,
    getUserDetailsinfo: getUserDetailsState,
    devices: devicesSlice,
    bbpsAccountSlice: bbpsAccountSlice,
    landingpagestate: landingpagestate,
    internalTxnViewall: internalTxnViewAllDataSlice,
    internalTxnViewData: internalTxnDataReducer,
    internalTxnSingleApproval: InternalTxnSingleApprovalReducer,
    internalTransactionCreate: InternalTransactionCreateReducer,
    ViewAllAccountInternal: ViewAllAccountInternalDataSlice,
    xpentraLogoutSlice: xpentraLogoutSlice,
    invoicesSlice: invoicesSlice,
    rolesSlice: rolesSlice,
    featuresSlice: featuresSlice,
    homeDashCalender: homeDashCalender,
    schedulesTxn: schedulesTxnSlice,
    scheduleInternalTxnSlice: scheduleInternalTxnSlice,
    schedulesTxnSlice: schedulesTxnSlice,
    reminderTxnSlice: reminderTxnSlice,
    customCategory: customCategoryReducer,
    beneCreateAccountSlice: beneCreateAccountSlice,
    TestAuthMatrix: TestAuthMatrix,
    internalAccLabelSlice: internalAccLabelSlice,
    multiEntitySwitcherSlice: multiEntitySwitcherSlice,
    settingStatistics: settingStatistics,
    privatetransactions: privateTransactionsReducer,
    roles: rolesReducer,
    reimbursementRequest: reimbursementRequest,
    reimbursementTransaction: reimbursementTransaction,
    taxCompliantAccountDetail: taxCompliantAccountDetailReducer,
    taxCompliantViewAll: taxCompliantViewAllReducer,
    taxCompliantApproveRejectAccount: taxCompliantApproveRejectAccountReducer,
    taxCompliantAccounts: taxCompliantAccountReducer,
    tdsTransactionApproval: tdsTransactionApprovalReducer,
    tdsTransactionDetails: tdsTransactionDetailsReducer,
    createTdsTransaction: createTdsTransactionReducer,
    tdsTxnViewAll: tdsTxnViewAllReducer,
    ReimburseAccount: ReimburseAccount,
    fieldForceAccount: fieldForceAccount,
    fieldForceRequest: fieldForceRequest,
    fieldForceTransaction: fieldForceTransaction,
    remitterAccount: remitterAccountReducer,
  },
});

injectStore(store);
